import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/profile/actionTypes';

import { validateFieldValue } from './utils';

export default function* listenSetField() {
  yield takeEvery(actionTypes.SET_FIELD_VALUE, validateFieldValue);
}
